import ModalNotifications from './ModalNotifications';
export default ModalNotifications;
